import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { BOOKING_URL, GOOGLE_REVIEW_URL, WHATSAPP_NUMBER } from "./config";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const DEFAULTS = { booking_url: BOOKING_URL, review_url: GOOGLE_REVIEW_URL, whatsapp_number: WHATSAPP_NUMBER };
const SiteSettingsContext = createContext({ ...DEFAULTS, update: () => {} });

export const useSiteSettings = () => useContext(SiteSettingsContext);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    axios
      .get(`${API}/settings`)
      .then(({ data }) =>
        setSettings({
          booking_url: data.booking_url || BOOKING_URL,
          review_url: data.review_url || GOOGLE_REVIEW_URL,
          whatsapp_number: data.whatsapp_number || WHATSAPP_NUMBER,
        })
      )
      .catch(() => {});
  }, []);
  const update = (patch) => setSettings((s) => ({ ...s, ...patch }));
  return <SiteSettingsContext.Provider value={{ ...settings, update }}>{children}</SiteSettingsContext.Provider>;
}
